<template>
<div>
    <ckeditor :editor="editor" @ready="onReady" @input="updateSelf($event)" v-model="editorData" :config="editorConfig"></ckeditor>
</div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials';
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold';
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic';
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link';
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import Font from '@ckeditor/ckeditor5-font/src/font';
import Image from '@ckeditor/ckeditor5-image/src/image';
import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar';
import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption';
import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle';
import ImageResize from '@ckeditor/ckeditor5-image/src/imageresize';
import LinkImage from '@ckeditor/ckeditor5-link/src/linkimage';
import EasyImage from '@ckeditor/ckeditor5-easy-image/src/easyimage';
import CKFinder from '@ckeditor/ckeditor5-ckfinder/src/ckfinder';
import Base64UploadAdapter from '@ckeditor/ckeditor5-upload/src/adapters/base64uploadadapter';
import Table from '@ckeditor/ckeditor5-table/src/table'
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar'

export default {
    props: {parentData: Object},
    data: () => ({
        test: "",
        editor: ClassicEditor,
        editorData: '',
        editorConfig: {
            plugins: [
                Table,
                TableToolbar,
                EssentialsPlugin,
                BoldPlugin,
                ItalicPlugin,
                LinkPlugin,
                ParagraphPlugin,
                Font,
                Image, ImageToolbar, ImageCaption, ImageStyle, ImageResize, LinkImage,
                EasyImage,
                CKFinder,
                Base64UploadAdapter
            ],

            image: {
                styles: [
                    // This option is equal to a situation where no style is applied.
                    'full',

                    // This represents an image aligned to left.
                    'alignLeft',

                    // This represents an image aligned to right.
                    'alignRight'
                ],
                toolbar: ['imageTextAlternative', '|', 'imageStyle:alignLeft', 'imageStyle:full', 'imageStyle:alignRight']
            },

            fontSize: {
                options: [
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    16,
                    17,
                    18,
                    19,
                    20
                ]
            },

            toolbar: {
                items: [
                    'fontFamily', 'fontSize', 'fontColor', 'fontBackgroundColor',
                    'bold',
                    'italic',
                    'link',
                    '|',
                    'undo',
                    'redo',
                    '|',
                    'imageStyle:full',
                    'imageStyle:alignLeft',
                    'imageStyle:alignRight',
                    'imageStyle:side',
                    'imageTextAlternative',
                    '|',
                    'tableColumn', 'tableRow', 'mergeTableCells',
                    '|',
                    'linkImage',
                    'imageUpload'
                ]
            },
            styles: [
                // This option is equal to a situation where no style is applied.
                'full',

                // This represents an image aligned to the left.
                'alignLeft',

                // This represents an image aligned to the right.
                'alignRight'
            ]
            // cloudServices: {
            //     tokenUrl: 'https://example.com/cs-token-endpoint',
            //     uploadUrl: 'https://your-organization-id.cke-cs.com/easyimage/upload/'
            // }
        }
    }),

    mounted() {
        // ClassicEditor
        //     .create(document.querySelector('#editor'), {
        //         fontSize: {
        //             options: [
        //                 'tiny',
        //                 'default',
        //                 'big'
        //             ]
        //         },
        //         plugins: [Font], // <--- MODIFIED
        //         toolbar: ['fontSize', 'fontFamily', 'fontColor', 'fontBackgroundColor', 'undo', 'redo'] // <--- MODIFIED
        //     })
        //     .then(editor => {
        //         console.log('Editor was initialized', editor);
        //     })
        //     .catch(error => {
        //         console.error(error.stack);
        //     });
        if (this.parentData) {
            this.editorData = this.parentData
            // this.$emit('input', this.editorData)
        }
        this.test = this.parentData;
        console.info("check", this.parentData);
        let tmp = this.parentData;
        let empty = ' '
        setTimeout(() => {
            this.editorData = "" + this.test + "" + empty;
        }, 100);
            console.log('fessfefes', this.parentData);

        // this.$EventBus.$on('editor', () => {
        //     this.editorData = 
        // })
    },

    // 에디터 사용하는 페이지에서 입력할때 데이터 감지하기 위한 코드
    watch: {
        parentData() {
            console.info("check2", this.parentData);
            this.editorData = this.parentData
        }
    },

    methods: {
        // CK에디터 입력받는 부분 업데이트
        updateSelf(event) {
            console.log('editor event', event)
            this.editorData = event
            this.$emit('input', this.editorData)
        },

        // CK에디터 렌더링 완료시 호출되는 함수 및 Toolbar 엘레멘트 활성화
        onReady(editor) {
            console.log('onready')
            // Insert the toolbar before the editable area.
            editor.ui.getEditableElement().parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            );
        }
    }

}
</script>
